import GetFromShuffled from '../utils/GetFromShuffled';

export default GetFromShuffled([
  `autobiographical novel`,
  `comedy`,
  `coming of age story`,
  `detective novel`,
  `epistolary novel`,
  `fairy tale`,
  `family drama`,
  `fictional memoir`,
  `graphic novel`,
  `historical novel`,
  `instant classic`,
  `meditation`,
  `murder mystery`,
  `noir`,
  `novel in stories`,
  `page-turner`,
  `romance`,
  `romp`,
  `saga`,
  `story`,
  `thriller`,
  `tour de force`,
  `tragedy`,
  `tragicomedy`,
  `trilogy`,
  `war epic`
])
